
import About from "pages/About";
import Contact from "pages/Contact";
import Features from "pages/Features";
import Home from "pages/Home";
import Privacy from "pages/Privacy";
import TermsAndConditions from "pages/TermsAndConditions";
import Blog from "crm/other/Blog";
import NotFound from "pages/NotFound";
import { Routes, Route } from "react-router-dom";
import Industries from "pages/Industries";
import DynamicPage from "pages/DynamicPage";

export default function AppRoutes() {
    return (
        <Routes>
            {/* Home Route */}
            <Route path="/" element={<Home />} />

            {/* Static Menu Routes - Must be defined before catch-all */}
            <Route path="/features" element={<Features />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/blogs" element={<Blog />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/termsAndConditions" element={<TermsAndConditions />} />

            {/* Dynamic Route for Blog/Industry Posts by Slug */}
            {/* This catches any URL like /blog-title-slug or /industry-slug and fetches data based on slug */}
            <Route path="/:slug" element={<DynamicPage />} />

            {/* 404 Not Found - Must be last */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
